export const SyncStatus = {
  None: "none",
  Syncing: "syncing",
  Pending: "pending",
  Deferred: "deferred",
} as const
